const asyncImport = require('util/asyncImport').default;

const CLASS_ACTIVE = 'active';

module.exports = {
	init() {
		this.root.__controller = this;
		this.video = null;
		if (!!this.root.dataset.captions) this.convertSrtToVtt();
	},

	async createVideo() {
		await asyncImport(this, 'Plyr');
		const isYoutube = !!this.root.querySelector('[data-plyr]');
		this.video = new this.Plyr(
			this.root.querySelector('.player'),
			isYoutube
				? {
						youtube: { rel: 0, cc_load_policy: 1, controls: 1 }, // rel: removes related videos, cc_load_policy: enables captions, controls: enables youtube default buttons
						controls: 0, // Disables custom controls
				  }
				: {},
		);
		this.root.classList.add(CLASS_ACTIVE);
		if (this.onReady) this.onReady();
	},

	play() {
		this.video.play();
	},

	on(eventName, callback) {
		this.video.on(eventName, callback);
	},
	convertSrtToVtt() {
		const isSrt = name => name.split('.').pop().toLowerCase() === 'srt';
		const tracks = this.root.querySelectorAll('track');
		tracks.forEach(track => {
			if (isSrt(track.src)) {
				fetch(track.src)
					.then(response => response.text())
					.then(text => {
						text = text.replace(/(\d+:\d+:\d+)+,(\d+)/g, '$1.$2');
						text = 'WEBVTT - Generated using SRT2VTT\r\n\r\n' + text;
						const blob = URL.createObjectURL(
							new Blob([text], { type: 'text/vtt' }),
						);
						track.src = blob;
					});
			}
		});
	},
};
